module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-spreadsheet-fill-c293921f.svg";